import { render, staticRenderFns } from "./VendorContactList.vue?vue&type=template&id=5092e3dd&scoped=true"
import script from "./VendorContactList.vue?vue&type=script&lang=js"
export * from "./VendorContactList.vue?vue&type=script&lang=js"
import style0 from "./VendorContactList.vue?vue&type=style&index=0&id=5092e3dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5092e3dd",
  null
  
)

export default component.exports